<template>
  <div class="flex flex-col rounded-[10px] min-w-[218px] bg-white shadow">
    <img :src="organizer.photoLink" alt="" class="rounded-t-[10px]">
    <p class="pt-4  pl-3.5 text-gray-900 font-bold text-[18px]">{{organizer.role}}</p>
    <div class="flex flex-row pl-3.5 pb-3.5 gap-2">
      <p class="text-gray-900 font-normal text-[18px]">{{organizer.name}}</p>
      <div>|</div>
      <a :href="organizer.linkedIn" target="_blank">
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.3629 20.6129H16.4365V13.7425C16.4365 11.8578 15.605 10.8063 14.1139 10.8063C12.4913 10.8063 11.5283 11.902 11.5283 13.7425V20.6129H7.60184V7.85184H11.5283V9.28689C11.5283 9.28689 12.7603 7.12521 15.5363 7.12521C18.3133 7.12521 20.3629 8.81982 20.3629 12.3262V20.6129ZM3.1276 5.81094C1.80339 5.81094 0.730469 4.72925 0.730469 3.39523C0.730469 2.06218 1.80339 0.980469 3.1276 0.980469C4.45083 0.980469 5.52373 2.06218 5.52373 3.39523C5.52472 4.72925 4.45083 5.81094 3.1276 5.81094ZM0.730469 20.6129H5.63859V7.85184H0.730469V20.6129Z" fill="#F6A02C"/>
      </svg>
      </a>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  organizer: Object,
})
</script>

<style scoped>

</style>
